const View = ({ properties, metadata }) => {
  return (
    <div className="documentSubtitle">
      {(metadata || properties)['subtitle'] || ''}
    </div>
  );
};

export default View;
